import React from 'react';
import DealsFAQ from '../dealList/components/deals/FAQ';
const FAQ: React.FC = () => {
    return <DealsFAQ defaultOpen={['1', '2', '3']} />;
};
export default FAQ;
